exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-photo-js": () => import("./../../../src/templates/photo.js" /* webpackChunkName: "component---src-templates-photo-js" */),
  "component---src-templates-photoalbum-js": () => import("./../../../src/templates/photoalbum.js" /* webpackChunkName: "component---src-templates-photoalbum-js" */)
}

